import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
// import SubscriberChart from "../common/dashboard9/sourceCodeChart";
import BasicLineColumn from "../common/apexChart/lineChart";
import {
  fetchLeakedCode,
  updateSourceCodeStatus,
  fetchLeakedCodeGraph,
  fetchLeakedCodeTotal,
  fetchLeakedCodeAction,
} from "../../actions/leakedCode";
import "../../assets/css/recommendation-modal.css";
import moment from "moment";
import Pagination from "../Pagination/Pagination";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import TrialComponent from "../common/trialComponent";
import NoData from "../common/noDataComponetnt";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import Dropdown from "react-bootstrap/Dropdown";
import { toastr } from "react-redux-toastr";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import $, { data } from "jquery";
import { rescanSingle } from "../../actions/users";
import PieChart from "../../components/common/dashboard12/piechart.js";
import { API_URL } from "../../utils/constant";
import ImageModal from "../common/ImageModal";

const SourceCodeLeakage = () => {
  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  }); const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.de?.e;
  });
  const auth = useSelector((state) => state?.auth?.user);
  const dispatch = useDispatch();
  const [select, setSelect] = useState("");
  const [filterData, setfilterData] = useState("all");
  const state = useSelector((state) => state?.leakedCode?.data?.data?.data);
  const paginationTotal = useSelector((state) => state?.leakedCode?.data?.data);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const scanCompleted = useSelector(
    (state) => state?.leakedCode?.scanCompleted
  );
  const [isModal, setModal] = useState("");
  const [limit, setLimit] = useState(10);
  const [repo, setRepo] = useState([]);
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [screenshotError, setScreenshotError] = useState(false);
  const [screenshotUrl, setScreenshotUrl] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageModalSrc, setImageModalSrc] = useState("");
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');
  const scanDetails = useSelector(
    (state) => state?.leakedCode?.sourceCodeGraph?.data
  );
  const totalRes = useSelector(
    (state) => state?.leakedCode?.sourceCodeTotal?.data
  );
  const [category, setCategory] = useState("all");
  let objArray = {};
  for (let count = 0; count < state?.length; count++) {
    let createdAt = state[count].createdAt.split("T")[0];
    if (objArray[createdAt]) {
      objArray[createdAt].push(state[count]);
    } else {
      objArray[createdAt] = [state[count]];
    }
  }
  let verifiedCode = [],
    unverifiedCode = [];
  let dateKey = [];
  Object.keys(objArray || {}).map((key) => {
    dateKey.push(key);
    let value = objArray[key];
    let verifiedData = value?.filter((val) => val?.isSuspicious);
    let unverifiedData = value?.filter((val) => !val?.isSuspicious);
    verifiedCode.push(verifiedData?.length || 0);
    unverifiedCode.push(unverifiedData?.length || 0);
  });
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const totalCount = state?.filter((row) => !row?.isFalsePositive);
  const verified = totalCount?.filter((row) => row?.isSuspicious);
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [search, setSearch] = useState("");
  const [action, setAction] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');


  useEffect(() => {
    fetchLeakedCode(id, dispatch, page, select, category, startDate, endDate, limit, search);
  }, [id, dispatch, page, PageSize, select, category, startDate, endDate, limit, search]);

  useEffect(() => {
    setTotalItems(paginationTotal?.totalLeakedCodes);
  }, [paginationTotal?.totalLeakedCodes]);

  useEffect(() => {
    fetchLeakedCodeGraph(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    fetchLeakedCodeTotal(id, dispatch);
  }, [id, dispatch]);

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const addModal = () => {
    setModal("Form Wizard modal");
  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      leakedCodeIds: selectedIds == 0 ? ids : selectedIds,
    };
    fetchLeakedCodeAction(id, dispatch, page, select, category, data);
    setSelectedIds([]);
  };

  const submit = () => {
    const data = {
      action: action,
      leakedCodeIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    fetchLeakedCodeAction(id, dispatch, page, select, category, data);
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  const snooze = (_id, event) => {
    if (event === "markAsRemidiated") {
      $.confirm({
        title: "Are you sure?",
        content: "Do you really want to mark this as remediated?",
        type: "green",
        buttons: {
          ok: {
            text: "Yes, Mark as Remediated",
            btnClass: "btn-success",
            keys: ["enter"],
            action: function () {
              let ids = [];
              ids.push(_id);
              const data = {
                action: "markAsRemediated",
                leakedCodeIds: selectedIds.length === 0 ? ids : selectedIds,
                actionNote: "",
                for: "forever",
              };
              fetchLeakedCodeAction(id, dispatch, page, select, category, data);
              setSelectedValue("pleaseSelect");
              setActionNote("");
              setSelectedIds([]);
            },
          },
          cancel: function () {
          },
        },
      });
    }

  };

  let mapData = state?.filter((row) => !row?.isFalsePositive);

  let currentTableData = [];

  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `https://api.brandsek.com/api/approved-code/${id}/excel`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}SourceCode Details.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const editModal = (row) => {
    setSelectedRowDetails(row);
    setDetailsModal(true);
  };

  // Manage body scroll when details modal is open
  useEffect(() => {
    if (detailsModal) {
      document.body.classList.add('details-slider-open');
    } else {
      document.body.classList.remove('details-slider-open');
    }
    // Cleanup on unmount
    return () => {
      document.body.classList.remove('details-slider-open');
    };
  }, [detailsModal]);

  // Reset screenshot state when selectedRowDetails changes
  useEffect(() => {
    if (selectedRowDetails?.screenshot_url) {
      setScreenshotError(false);
      setScreenshotUrl(selectedRowDetails.screenshot_url);
    } else {
      setScreenshotError(false);
      setScreenshotUrl(null);
    }
  }, [selectedRowDetails]);

  const clearFilter = () => {
    setPage(1);
    setSelect("all");
    setSelectedIds([]);
    setSearch("");
  }

  const reScan = () => {
    let data = {
      "moduleName": ["sourceCodeLeakage"]
    }
    rescanSingle(id, data)
  }

  const updateSuspiciousStatus = async (isSuspicious) => {
    if (selectedIds.length === 0) {
      toastr.error("Error", "Please select at least one record.");
      return;
    }

    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      
      const response = await axios.put(
        `${API_URL}/approved-code/${id}/update-suspicious-status`,
        {
          _ids: selectedIds,
          isSuspicious: isSuspicious
        }
      );

      if (response.data) {
        toastr.success("Success", `Records marked as ${isSuspicious ? 'verified' : 'unverified'} successfully.`);
        // Refresh the data
        fetchLeakedCode(id, dispatch, page, select, category, startDate, endDate, limit, search);
        // Clear selections
        setSelectedIds([]);
        setMultiCheckTrue(false);
      }
    } catch (error) {
      toastr.error("Error", "Failed to update suspicious status.");
      console.error("Error updating suspicious status:", error);
    }
  };

  const series = [
    totalRes?.totalLeakedCodes || 0,
    // totalRes?.totalVerifiedLeakedCodes || 0,
    // totalRes?.totalTakenDownLeakedCodes || 0,
  ];

  const labels = ["Total Leaked Records"];




  return (
    <>
      <div className="container-fluid">
        <AccessPage></AccessPage>
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1 className="welcome-text">Source Code Leakage</h1>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    {vendorId ? <>
                      <Link to="/vendor"
                        onClick={(() => {
                          sessionStorage.clear();
                        })}
                      >Vendor Assessment</Link>
                    </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                  </li>
                  {
                    vendorName ?
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                        style={{ color: "white" }}
                      >
                        <Link to={`/dashboard/vendor/${vendorId}`}
                        >{vendorName}</Link>
                      </li> : ''
                  }
                  <li
                    className="breadcrumb-item active"
                    aria-current="page"
                    style={{ color: "white" }}
                  >
                    Source Code Leakage
                  </li>
                </ol>
                <br />
              </nav>
            </div>
            <div className="col-md-6 col-sm-12 hidden-xs d-flex justify-content-end align-items-center">
              <span>
                {auth?.accessLevel == "Admin" && (
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      reScan();
                    }}
                    style={{ color: "black", fontWeight: "bold" }}
                    className="btn btn-primary mr-1"
                  >
                    Rescan
                  </a>
                )}
              </span>
              <span className="mr-2">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    setIsRecommendationModal(true);
                  }}
                  href="#"
                  className="btn btn-sm btn-primary mr-1"
                  style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
                >
                  <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
                  Recommendation
                </a>
              </span>
              <span>
                {client?.subscriptionType != "trial" && mapData?.length !== 0 && (
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      downloadFile();
                    }}
                    href="/add-report"
                    className="btn btn-sm btn-primary mr-1 download-report"
                  >
                    Download Details
                  </a>
                )}
              </span>
            </div>
          </div>
        </div>

        {typeof scanCompleted !== "undefined" && !scanCompleted && (
          <div className="card border-success">
            <ScanMessage />
          </div>
        )}

        <div className="row clearfix">
          <div className="col-lg-4 col-md-12">
            <div className="card RecordFoundCard">
              <div className="body" style={{ minHeight: "460px" }}>
                <h6 className="mb-4">Records Found</h6>
                <div className="d-flex mb-4 justify-content-center">
                  {series && series?.length > 0 && <PieChart series={series} label={labels} />}
                </div>
                
                <div className="form-group">
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                    onClick={() => setfilterData("verified")}
                  >
                    <span className="greenShadow"></span>
                    Total Leaked Records{" "}
                    <span className="float-right">
                      {(totalRes?.totalLeakedCodes || 0)?.toFixed(0)}
                    </span>
                  </label>
                </div>

                <div className="form-group">
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                    onClick={() => setfilterData("verified")}
                  >
                    <span className="redShadow"></span>
                    Verified Records{" "}
                    <span className="float-right">
                      {(totalRes?.totalVerifiedLeakedCodes || 0)?.toFixed(0)}
                    </span>
                  </label>
                </div>

                <div className="form-group">
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                    onClick={() => setfilterData("takedown")}
                  >
                    <span className="yellowShadow"></span>
                    Records Taken Down{" "}
                    <span className="float-right">
                      {(totalRes?.totalTakenDownLeakedCodes || 0)?.toFixed(0)}
                    </span>
                  </label>
                </div>
                {client?.subscriptionType == "trial" && (
                  <div className="card border-warning">
                    <TrialComponent />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-md-12 col-sm-12">
            <div className="card">
              <div className="body" style={{ minHeight: "460px" }}>
                <h6 className="welcome-textSmall">Previous scan details</h6>
                {scanDetails && (
                  <BasicLineColumn
                    dates={scanDetails?.dates}
                    ipArray={scanDetails?.scanDetails}
                    color={["#08283f"]}
                    yAxis="Records Found"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
          <li className="nav-item">
            <a
              className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("all");
                clearFilter();
              }}
            >
              Current
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("risk-accepted");
                clearFilter();
              }}
            >
              Risk Accepted
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("false-positive");
                clearFilter();
              }}
            >
              False Positive
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("remidiated");
                clearFilter();
              }}
            >
              Remediated
            </a>
          </li>
        </ul>
        <div className="card card_tableBox">
          <div className="body">
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="row clearfix">
                  <div className="col-lg-4 col-md-12 mb-2">
                    <select
                      className="custom-select custom-select-sm form-control form-control-sm"
                      value={filterData}
                      onChange={(e) => {
                        setSelect(e.target.value);
                        setPage(1);
                      }}
                    >
                      <option value="all">All</option>
                      <option value="verified">Verified</option>
                      <option value="unverified">Unverified</option>
                      <option value="takedown">takedown</option>
                      <option value="falsePositive">FalsePositive</option>
                    </select>
                  </div>
                  <div className="col-lg-4 col-md-12 mb-2">
                    <input
                      onChange={(e) => {
                        setSearch(e.target.value);
                        setPage(1);
                      }}
                      placeholder="Search"
                      className="mb-2 form-control form-control-sm"
                    />
                  </div>
                  <div className="col-sm-4 d-flex align-items-end mb-2">
                    <label htmlFor="startDate">From:</label>
                    <input
                      type="date"
                      className="ml-1 form-control form-control-sm"
                      id="startDate"
                      value={startDate}
                      onChange={(e) => {
                        setStartDate(e.target.value);
                        setPage(1);
                      }}
                    />
                  </div>
                  <div className="col-sm-4 d-flex align-items-end mb-2">
                    <label htmlFor="endDate">Till:</label>
                    <input
                      type="date"
                      className="ml-1 form-control form-control-sm"
                      id="endDate"
                      value={endDate}
                      onChange={(e) => {
                        setEndDate(e.target.value);
                        setPage(1);
                      }}
                    />
                  </div>
                  <div className="col-lg-4 col-md-12 mb-2">
                    {selectedIds.length > 1 && userPermission && category === "all" && (
                      <Box sx={{ width: 160 }}>
                        <FormControl fullWidth>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedValue}
                            onChange={(event) => {
                              setAction(event.target.value);
                              snooze("", event.target.value);
                            }}
                          >
                            <MenuItem value="pleaseSelect">
                              Snooze Options
                            </MenuItem>
                            <MenuItem
                              value="riskAccepted"
                              onClick={() => {
                                addModal();
                              }}
                            >
                              Risk Accepted
                            </MenuItem>
                            <MenuItem
                              value="markAsFalsePositive"
                              onClick={() => {
                                addModal();
                              }}
                            >
                              False Positive
                            </MenuItem>
                            <MenuItem value="markAsRemidiated">
                              Remediated
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    )}
                    {selectedIds.length > 1 && userPermission &&
                      (category == "false-positive" ||
                        category == "risk-accepted") && (
                        <button
                          className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                          onClick={() => Unsnoozed("")}
                        >
                          Unsnooze
                        </button>
                      )}
                  </div>
                  <div className="col-lg-4 col-md-12 mb-2">
                    {selectedIds.length > 0 && userPermission && category === "all" && auth?.accessLevel === "super-admin" && (
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-success btn-sm mr-1 mb-2"
                          onClick={() => updateSuspiciousStatus(true)}
                          title="Mark selected records as verified"
                        >
                          <i className="fa fa-check mr-1"></i>
                          Mark as Verified
                        </button>
                        <button
                          className="btn btn-warning btn-sm mr-1 mb-2"
                          onClick={() => updateSuspiciousStatus(false)}
                          title="Mark selected records as unverified"
                        >
                          <i className="fa fa-times mr-1"></i>
                          Mark as Unverified
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-custom spacing5 mb-0" style={{ tableLayout: "auto", width: "100%" }}>
                    <thead>
                      <tr>
                        {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <th>
                              <input
                                type="checkbox"
                                checked={
                                  selectedIds == 0 ? false : multiCheckTrue
                                }
                                onClick={() => {
                                  multicheck(currentTableData);
                                }}
                                className="checkUncheck"
                              />
                            </th>
                          )}
                        {/* <th>#</th> */}
                        {auth.accessLevel !== "Client" && <th>Status</th>}
                        {/* <th style={{ width: "40" }}>Platform</th> */}
                        <th style={{ 
                          whiteSpace: "normal", 
                          wordBreak: "break-word",
                          maxWidth: "250px",
                          minWidth: "200px"
                        }}>Repository Link</th>
                        <th style={{ 
                          whiteSpace: "normal",
                          maxWidth: "120px",
                          minWidth: "100px"
                        }}>Last Update at</th>
                        <th>Created at</th>
                        <th>Detail</th>
                        {category !== "all" && <th>Action Note</th>}
                        {/* <th>Actions</th> */}
                        {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <th style={{ width: "80" }}>Action</th>
                          )}
                      </tr>
                    </thead>
                    <tbody>
                      {client?.subscriptionType == "trial" ? (
                        <tr>
                          <td colSpan={5}>
                            <NoData />
                          </td>
                        </tr>
                      ) : (
                        currentTableData?.map((res, index) => (
                          <tr key={index}>
                            {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                              category === "risk-accepted" ||
                              category === "false-positive") && (
                                <td>
                                  <input
                                    onClick={() => singleClick(res?._id)}
                                    checked={selectedIds?.includes(res?._id)}
                                    type="checkbox"
                                    className="checkUncheck"
                                  />
                                </td>
                              )}
                            {/* <td style={{ whiteSpace: "unset" }}>
                              <span>{(page - 1) * 10 + 1 + index}</span>
                            </td> */}
                            {auth.accessLevel !== "Client" && (
                              <td>
                                {" "}
                                <span
                                  className={
                                    res?.isSuspicious
                                      ? "badge badge-success"
                                      : "badge badge-danger"
                                  }
                                >
                                  {res?.isSuspicious
                                    ? "Verified Threat"
                                    : "Unverified Threat"}
                                </span>
                                {res?.isLinkDown && (
                                  <span className="badge badge-warning">
                                    Link down
                                  </span>
                                )}
                              </td>
                            )}

                            {/* <td style={{ whiteSpace: "unset" }}>
                              <i className="fa fa-github"></i>
                              GitHub
                            </td> */}
                            {/* <td>{res?.keyword||"-"}</td> */}
                            <td style={{ 
                              whiteSpace: "normal",
                              wordBreak: "break-all",
                              overflowWrap: "break-word",
                              maxWidth: "250px",
                              minWidth: "200px",
                              verticalAlign: "top",
                              padding: "8px",
                              lineHeight: "1.5"
                            }}>
                              {res?.repoUrl ? (
                                <a
                                  href={res.repoUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ 
                                    color: "#17a2b8",
                                    textDecoration: "none",
                                    wordBreak: "break-all",
                                    overflowWrap: "break-word",
                                    display: "inline-block",
                                    maxWidth: "100%"
                                  }}
                                >
                                  {res.repoUrl}
                                </a>
                              ) : "N/A"}
                            </td>
                            {/* <td style={{ whiteSpace: "unset" }}>{res?.leakedCode||"-"}</td> */}
                            {/* <td>Screenshot</td> */}
                            <td style={{ 
                              whiteSpace: "normal",
                              maxWidth: "120px",
                              minWidth: "100px",
                              verticalAlign: "top",
                              padding: "8px",
                              textAlign: "center"
                            }}>
                              {res?.updatedAt
                                ? moment(res?.updatedAt).format(
                                  "DD-MM-YYYY"
                                )
                                : res?.createdAt
                                  ? moment(res?.createdAt).format(
                                    "DD-MM-YYYY"
                                  )
                                  : "NA"}
                            </td>
                            <td>
                              {" "}
                              {res?.date
                                ? moment(res?.date).format("DD-MM-YYYY")
                                : res?.createdAt
                                  ? moment(res?.createdAt).format(
                                    "DD-MM-YYYY"
                                  )
                                  : "NA"}
                            </td>
                            <td>
                              <button
                                className="btn btn-sm"
                                onClick={() => editModal(res)}
                                style={{
                                  backgroundColor: "#17a2b8",
                                  borderColor: "#17a2b8",
                                  color: "#fff",
                                  borderRadius: "4px",
                                  padding: "4px 12px",
                                  transition: "all 0.3s ease",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "6px"
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.backgroundColor = "#138496";
                                  e.target.style.borderColor = "#117a8b";
                                  e.target.style.transform = "translateY(-1px)";
                                  e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.backgroundColor = "#17a2b8";
                                  e.target.style.borderColor = "#17a2b8";
                                  e.target.style.transform = "translateY(0)";
                                  e.target.style.boxShadow = "none";
                                }}
                              >
                                <i className="fa fa-info-circle" style={{ fontSize: "14px" }}></i>
                                <span className="details-slider-action-btn-text">Details</span>
                              </button>
                            </td>
                            {category !== "all" && <td style={{ whiteSpace: "unset" }}>{res?.actionNote ? res.actionNote : "N/A"}</td>}
                            {res?.remediationPending == true ? <td>Retest in progress</td> : <>
                              {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                                <td>
                                  <div className="d-flex flex-column gap-2">
                                    <Box sx={{ width: 160 }}>
                                      <FormControl fullWidth>
                                        <Select
                                          labelId="demo-simple-select-label"
                                          id="demo-simple-select"
                                          value={selectedValue}
                                          onChange={(event) => {
                                            setAction(event.target.value);
                                            snooze(res?._id, event.target.value);
                                          }}
                                        >
                                          <MenuItem value="pleaseSelect">
                                            Snooze Options
                                          </MenuItem>
                                          <MenuItem
                                            value="riskAccepted"
                                            onClick={() => {
                                              addModal();
                                              setLookalikeAppId([res._id]);
                                            }}
                                          >
                                            Risk Accepted
                                          </MenuItem>
                                          <MenuItem
                                            value="markAsFalsePositive"
                                            onClick={() => {
                                              addModal();
                                              setLookalikeAppId([res._id]);
                                            }}
                                          >
                                            False Positive
                                          </MenuItem>
                                          <MenuItem value="markAsRemidiated">
                                            Remediated
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Box>
                                  </div>
                                </td>
                              )}</>}
                            {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" ||
                              category === "false-positive") && (
                                <td>
                                  <button
                                    className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                    onClick={() => Unsnoozed(res?._id)}
                                  >
                                    Unsnooze
                                  </button>
                                </td>
                              )}
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="dataTables_paginate">
                    {totalItems > 0 && (
                      <Pagination
                        className="pagination-bar"
                        currentPage={page}
                        totalCount={totalItems}
                        pageSize={limit}
                        onPageChange={(page) => {
                          setPage(page);
                        }}
                      />
                    )}
                  </div>
                  {totalItems > 10 && (
                    <select
                      value={limit}
                      onChange={(e) => {
                        setLimit(e.target.value)
                      }}
                      className="form-control limitSelectBox"
                    >
                      <option value={10}>10 per page</option>
                      <option value={25}>25 per page</option>
                      <option value={50}>50 per page</option>
                      <option value={100}>100 per page</option>
                    </select>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      {/* Source Code Leakage Details Slider */}
      <div
        className={`details-slider-overlay ${detailsModal ? "show" : ""}`}
        onClick={() => {
          setDetailsModal(false);
          setSelectedRowDetails(null);
        }}
      ></div>
      <div className={`details-slider-panel ${detailsModal ? "open" : ""}`}>
        <div className="details-slider-content">
          <div className="details-slider-header">
            <h5 style={{ color: "white", margin: 0 }}>
              <i className="fa fa-code mr-2"></i>
              Source Code Leakage Details
              {selectedRowDetails?.repoUrl && (
                <span className="ml-2" style={{ fontSize: "0.85em", opacity: 0.9, color: "white" }}>
                  - {selectedRowDetails.repoUrl.split('/').pop() || selectedRowDetails.repoUrl}
                </span>
              )}
            </h5>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <button
                type="button"
                className="details-slider-close"
                onClick={() => {
                  setDetailsModal(false);
                  setSelectedRowDetails(null);
                }}
                aria-label="Close"
              >
                <i className="fa fa-times"></i>
              </button>
            </div>
          </div>
          <div className="details-slider-body">
            {selectedRowDetails && (
              <>
                {/* Risk Description Section */}
                {selectedRowDetails?.risk_description && (
                  <div className="details-section" style={{ borderColor: "#ffc107", backgroundColor: "#fff3cd" }}>
                    <div className="details-section-title" style={{ color: "#856404" }}>
                      <i className="fa fa-exclamation-triangle" style={{ color: "#856404" }}></i>
                      Risk Description
                    </div>
                    <div className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                      <p style={{ color: "#856404", margin: 0, lineHeight: "1.6" }}>
                        {selectedRowDetails.risk_description}
                      </p>
                    </div>
                  </div>
                )}

                {/* Impact Section */}
                {selectedRowDetails?.impact && (
                  <div className="details-section" style={{ borderColor: "#dc3545", backgroundColor: "#f8d7da" }}>
                    <div className="details-section-title" style={{ color: "#721c24" }}>
                      <i className="fa fa-exclamation-circle" style={{ color: "#721c24" }}></i>
                      Impact
                    </div>
                    <div className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                      <p style={{ color: "#721c24", margin: 0, lineHeight: "1.6" }}>
                        {selectedRowDetails.impact}
                      </p>
                    </div>
                  </div>
                )}

                {/* Basic Information Section */}
                <div className="details-section">
                  <div className="details-section-title">
                    <i className="fa fa-info-circle"></i>
                    Basic Information
                  </div>
                  <div className="details-info-item">
                    <span className="details-info-label">Repository URL:</span>
                    <span className="details-info-value">
                      {selectedRowDetails?.repoUrl ? (
                        <a href={selectedRowDetails.repoUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#17a2b8", wordBreak: "break-all" }}>
                          {selectedRowDetails.repoUrl}
                        </a>
                      ) : "N/A"}
                    </span>
                  </div>
                  {selectedRowDetails?.git_url && (
                    <div className="details-info-item">
                      <span className="details-info-label">Git URL:</span>
                      <span className="details-info-value">
                        <a href={selectedRowDetails.git_url} target="_blank" rel="noopener noreferrer" style={{ color: "#17a2b8", wordBreak: "break-all" }}>
                          {selectedRowDetails.git_url}
                        </a>
                      </span>
                    </div>
                  )}
                  {selectedRowDetails?.scan_input && (
                    <div className="details-info-item">
                      <span className="details-info-label">Scan Input:</span>
                      <span className="details-info-value">
                        <code style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px", wordBreak: "break-all" }}>
                          {selectedRowDetails.scan_input}
                        </code>
                      </span>
                    </div>
                  )}
                  <div className="details-info-item">
                    <span className="details-info-label">Status:</span>
                    <span className="details-info-value">
                      <span className={`badge ${selectedRowDetails?.isSuspicious ? 'badge-success' : 'badge-danger'}`}>
                        {selectedRowDetails?.isSuspicious ? 'Verified Threat' : 'Unverified Threat'}
                      </span>
                      {selectedRowDetails?.isLinkDown && (
                        <span className="ml-2 badge badge-warning">Link Down</span>
                      )}
                    </span>
                  </div>
                  
                  {selectedRowDetails?.actionNote && (
                    <div className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                      <span className="details-info-label" style={{ marginBottom: "8px" }}>Action Note:</span>
                      <span className="details-info-value" style={{ padding: "8px", backgroundColor: "#f8f9fa", borderRadius: "4px", width: "100%" }}>
                        {selectedRowDetails.actionNote}
                      </span>
                    </div>
                  )}
                </div>

                {/* Screenshot Section */}
                {selectedRowDetails?.screenshot_url && (
                  <div className="details-section">
                    <div className="details-section-title">
                      <i className="fa fa-image"></i>
                      Screenshot
                    </div>
                    <div style={{ 
                      display: "flex", 
                      justifyContent: "center", 
                      alignItems: "center",
                      padding: "15px",
                      backgroundColor: "#f8f9fa",
                      borderRadius: "4px",
                      minHeight: "200px"
                    }}>
                      {screenshotError ? (
                        <div style={{ textAlign: "center", padding: "20px", color: "#6c757d" }}>
                          <i className="fa fa-exclamation-triangle" style={{ fontSize: "24px", marginBottom: "10px", display: "block", color: "#ffc107" }}></i>
                          <p style={{ marginBottom: "10px" }}>Unable to load screenshot</p>
                          <a 
                            href={selectedRowDetails.screenshot_url} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            style={{ color: "#453acd", textDecoration: "underline" }}
                          >
                            <i className="fa fa-external-link mr-1"></i>
                            Open screenshot URL
                          </a>
                        </div>
                      ) : (
                        <img
                          src={screenshotUrl || selectedRowDetails.screenshot_url}
                          alt="Screenshot"
                          className="image-clickable"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "500px",
                            borderRadius: "4px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            objectFit: "contain"
                          }}
                          onClick={() => {
                            setImageModalSrc(screenshotUrl || selectedRowDetails.screenshot_url);
                            setImageModalOpen(true);
                          }}
                          onError={() => {
                            // Set error state to show fallback UI
                            setScreenshotError(true);
                          }}
                          onLoad={() => {
                            setScreenshotError(false);
                          }}
                          title="Click to open in new tab"
                        />
                      )}
                    </div>
                    <div style={{ marginTop: "10px", textAlign: "center" }}>
                      <a 
                        href={selectedRowDetails.screenshot_url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ 
                          color: "#453acd", 
                          textDecoration: "none",
                          fontSize: "0.85rem"
                        }}
                      >
                        <i className="fa fa-external-link mr-1"></i>
                        Open screenshot in new tab
                      </a>
                    </div>
                  </div>
                )}

                {/* Repository Details Section - Only show if data exists */}
                {selectedRowDetails?.repository && selectedRowDetails.repository.length > 0 && (
                  selectedRowDetails.repository.map((repositoryItem, index) => (
                    <div key={index} className="details-section">
                      <div className="details-section-title">
                        <i className="fa fa-code"></i>
                        Repository Item {index + 1}
                      </div>
                      {repositoryItem?.leakedCode && (
                        <div className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                          <span className="details-info-label" style={{ marginBottom: "8px" }}>Leaked Code:</span>
                          <code style={{ backgroundColor: "#f8f9fa", padding: "8px", borderRadius: "4px", fontSize: "0.85em", wordBreak: "break-all", width: "100%", display: "block" }}>
                            {repositoryItem.leakedCode}
                          </code>
                        </div>
                      )}
                      {repositoryItem?.snippet && (
                        <div className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                          <span className="details-info-label" style={{ marginBottom: "8px" }}>Code Snippet:</span>
                          <pre style={{ 
                            backgroundColor: "#f8f9fa", 
                            padding: "12px", 
                            borderRadius: "4px", 
                            fontSize: "0.85em", 
                            maxHeight: "200px", 
                            overflow: "auto", 
                            whiteSpace: "pre-wrap", 
                            wordBreak: "break-word",
                            width: "100%",
                            margin: 0
                          }}>
                            {repositoryItem.snippet?.replace(/\\n/g, '\n')}
                          </pre>
                        </div>
                      )}
                      {repositoryItem?.securityRisk && (
                        <div className="details-info-item">
                          <span className="details-info-label">Security Risk:</span>
                          <span className="details-info-value">
                            <span className="badge badge-warning">{repositoryItem.securityRisk}</span>
                          </span>
                        </div>
                      )}
                      {repositoryItem?.severity && (
                        <div className="details-info-item">
                          <span className="details-info-label">Severity:</span>
                          <span className="details-info-value">
                            <span className={`badge ${
                              repositoryItem.severity === 'high' ? 'badge-danger' : 
                              repositoryItem.severity === 'medium' ? 'badge-warning' : 
                              'badge-info'
                            }`}>
                              {repositoryItem.severity?.toUpperCase()}
                            </span>
                          </span>
                        </div>
                      )}
                    </div>
                  ))
                )}
              </>
            )}
          </div>
        </div>
      </div>
        <div
          className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {action == "markAsFalsePositive"
                    ? "Mark As False Positive"
                    : "Risk Accepted"}
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModal("");
                    setActionNote("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <label className="col-lg-6 col-md-12">Snooze for</label>
                        <div className="form-group ol-lg-12 col-md-12">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            onChange={(e) => { setForValue(e.target.value); setPage(1) }}
                          >
                            <option value="forever">Forever</option>
                            <option value="3 months">3 Months</option>
                            <option value="6 months">6 Months</option>
                            <option value="12 months">12 Months</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12">Detail</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <textarea
                            onChange={(e) => setActionNote(e.target.value)}
                            value={actionNote}
                            className="form-control"
                            rows="3"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-lg-12 col-md-12"
                        style={{ marginRight: "28px" }}
                      >
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          onClick={submit}
                          className="btn btn-round btn-primary mr-1 pull-right"
                        >
                          Submit
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="button"
                          onClick={() => {
                            setModal("");
                            setActionNote("");
                          }}
                          className="btn btn-round btn-default pull-right"
                          style={{ marginRight: "10px" }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ImageModal
        isOpen={imageModalOpen}
        onClose={() => setImageModalOpen(false)}
        imageSrc={imageModalSrc}
      />

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>
            
            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek monitors public code repositories (GitHub, GitLab, Bitbucket), paste sites, and Postman collections for inadvertent exposure of proprietary source code, credentials, and API documentation.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What Is Source Code Leakage</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Source code leakage occurs when internal application code, scripts, or configuration files are unintentionally published to public repositories, paste sites, or file-sharing platforms, exposing business logic, vulnerabilities, and credentials.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Postman Monitoring Context</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Postman collections often contain API endpoints, authentication tokens, and request/response examples. When accidentally published publicly, they provide attackers with detailed API reconnaissance and credential access.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Why This Exposure Is High Risk</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Proprietary business logic and algorithms revealed</li>
                      <li>Hardcoded credentials, API keys, and secrets exposed</li>
                      <li>Internal API endpoints and authentication mechanisms disclosed</li>
                      <li>Vulnerabilities and security weaknesses easily identified</li>
                      <li>Intellectual property theft and competitive disadvantage</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Threat Actor Exploitation Scenarios</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Extracting credentials for unauthorized system access</li>
                      <li>Identifying vulnerabilities for targeted exploitation</li>
                      <li>Reverse-engineering business logic for competitive intelligence</li>
                      <li>Abusing exposed API endpoints for data exfiltration</li>
                      <li>Using Postman collections to automate attacks</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Governance & Compliance Impact</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Source code leakage may violate ISO 27001 (A.14.1.2 - secure development), RBI cybersecurity guidelines, and intellectual property protection regulations. Organizations must demonstrate secure code management practices and credential hygiene.
                    </p>
                  </div>
                </details>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Immediate Exposure Containment</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Remove or set repository/collection to private immediately</li>
                      <li>Request takedown from platform operators if needed</li>
                      <li>Archive exposure evidence for incident investigation</li>
                      <li>Verify scope of exposed code and files</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.16.1.2 · Incident Response</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Secrets Tokens & Identifier Rotation</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Rotate all exposed API keys, tokens, and passwords</li>
                      <li>Revoke OAuth tokens and cloud access credentials</li>
                      <li>Update database credentials and connection strings</li>
                      <li>Review access logs for unauthorized API usage</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.9.4.3 · NIST SP 800-53 IA-5</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Impact Assessment & Abuse Review</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Assess business logic and vulnerability exposure</li>
                      <li>Check for signs of credential or API abuse</li>
                      <li>Determine exposure duration from commit history</li>
                      <li>Investigate source of leak (developer error, misconfiguration)</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.16.1.4 · Forensic Investigation</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Development & Access Control Hardening</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Implement secret scanning in CI/CD pipelines (e.g., GitGuardian, TruffleHog)</li>
                      <li>Enforce .gitignore rules for sensitive files</li>
                      <li>Use secret management tools (HashiCorp Vault, AWS Secrets Manager)</li>
                      <li>Conduct secure coding and Git hygiene training</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.14.2.6 · NIST CSF PR.DS-5</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Monitoring Documentation & Audit</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Enable continuous repository and Postman collection monitoring</li>
                      <li>Document incident timeline and remediation steps</li>
                      <li>Update risk register with source code leakage risk</li>
                      <li>Review and enforce secure code management policies</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.12.4.1 · Risk Management</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SourceCodeLeakage;
